/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { FC, ReactNode } from "react";
import { createUseStyles } from "react-jss";
import styles from "./styles";

interface Props {
  // This are named slots.  Being slots, they will have their events already attached to them and SearchOptions only job is to display them.
  arrowSlot?: ReactNode; // This will be the arrow
  slot1?: ReactNode; // This will be dynamic
  slot2?: ReactNode; // This will be dynamic
  slot3?: ReactNode; // This will be dynamic
  currentLabel?: ReactNode; // This will be dynamic
  hasDivider?: boolean; // This will be dynamic
  showTrails?: boolean;
  textLabel?: ReactNode;
}

const SearchOptions: FC<Props> = (props: Props) => {
  const {
    currentLabel,
    textLabel,
    slot1,
    slot2,
    slot3,
    arrowSlot,
    hasDivider = true,
    showTrails,
  } = props;
  const useStyles = createUseStyles(styles);
  const classes = useStyles({ ...props });

  return (
    <div id="searchoptions" className={classes.container}>
      <div className={`${classes.iconContainer} ${classes.iconContainerLeft}`}>
        <div
          className={classes.flex}
          id="searchOptionsTitle"
          tabIndex={
            currentLabel && currentLabel.props?.text === "Destinations" ? -1 : 0
          }
          aria-label={textLabel && textLabel.props?.text}
        >
          {arrowSlot && (
            <div id="arrowSlot" className={classes.arrowSlot}>
              {arrowSlot}
            </div>
          )}
          {slot1 && (
            <div id="slot1" className={classes.slot1}>
              {slot1}
            </div>
          )}
          {currentLabel && (
            <div id="currentLabel" className={classes.currentLabel}>
              {currentLabel}
            </div>
          )}
          {textLabel && (
            <div id="textLabel" className={classes.currentLabel}>
              {textLabel}
            </div>
          )}
        </div>
      </div>
      <div className={`${classes.iconContainer} ${classes.iconContainerRight}`}>
        <div className={classes.flex}>
          {slot2 && (
            <div
              id="slot2"
              className={`${classes.slot2} ${
                // eslint-disable-next-line dot-notation
                currentLabel && currentLabel["props"].text === "Directions"
                  ? classes.slotDisplay
                  : ""
              }`}
            >
              {slot2}
            </div>
          )}

          {hasDivider && (
            <div
              className={`${classes.separatorContainer} ${
                showTrails ? "" : classes.hideOnMobileLandscape
              } ${
                // eslint-disable-next-line dot-notation
                currentLabel && currentLabel["props"].text === "Trails"
                  ? classes.slotDisplay
                  : ""
              }`}
            >
              <div id="divider" className={classes.separator} />
            </div>
          )}
          {slot3 && (
            <div
              id="slot3"
              className={`${classes.slot3}  ${
                // eslint-disable-next-line dot-notation
                currentLabel && currentLabel["props"].text === "Trails"
                  ? classes.slotDisplay
                  : ""
              }`}
            >
              {slot3}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

SearchOptions.defaultProps = {
  arrowSlot: undefined,
  slot1: undefined,
  slot2: undefined,
  slot3: undefined,
  currentLabel: undefined,
  hasDivider: undefined,
  showTrails: undefined,
  textLabel: undefined,
};
export default SearchOptions;
try {
    // @ts-ignore
    SearchOptions.displayName = "SearchOptions";
    // @ts-ignore
    SearchOptions.__docgenInfo = { "description": "", "displayName": "SearchOptions", "props": { "arrowSlot": { "defaultValue": { value: "undefined" }, "description": "", "name": "arrowSlot", "required": false, "type": { "name": "ReactNode" } }, "slot1": { "defaultValue": { value: "undefined" }, "description": "", "name": "slot1", "required": false, "type": { "name": "ReactNode" } }, "slot2": { "defaultValue": { value: "undefined" }, "description": "", "name": "slot2", "required": false, "type": { "name": "ReactNode" } }, "slot3": { "defaultValue": { value: "undefined" }, "description": "", "name": "slot3", "required": false, "type": { "name": "ReactNode" } }, "currentLabel": { "defaultValue": { value: "undefined" }, "description": "", "name": "currentLabel", "required": false, "type": { "name": "ReactNode" } }, "hasDivider": { "defaultValue": { value: "undefined" }, "description": "", "name": "hasDivider", "required": false, "type": { "name": "boolean" } }, "showTrails": { "defaultValue": { value: "undefined" }, "description": "", "name": "showTrails", "required": false, "type": { "name": "boolean" } }, "textLabel": { "defaultValue": { value: "undefined" }, "description": "", "name": "textLabel", "required": false, "type": { "name": "ReactNode" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/SearchOptions/SearchOptions.tsx#SearchOptions"] = { docgenInfo: SearchOptions.__docgenInfo, name: "SearchOptions", path: "src/shared/components/SearchOptions/SearchOptions.tsx#SearchOptions" };
}
catch (__react_docgen_typescript_loader_error) { }